<template>
  <div class="home">
    <button class="home__comic" @click="$emit('openModal', 'comics')"
      aria-label="Button to open comic modal"></button>
    <img class="home__hal" src="../assets/anim/hal.gif" />
    <img class="home__frank" src="../assets/anim/frank.gif" />
    <img class="home__queen" src="../assets/anim/queen.gif" />
    <img class="home__bro" src="../assets/anim/bro.gif" />
  </div>
</template>

<script>
import callApi from '@/helpers/callApi';
import H from '@/helpers/H';

export default {
  name: 'Home',
  data() {
    return {
      fromApi: [],
      comics: [],
      retry: 0,
    };
  },
  methods: {
    getComics() {
      callApi.getComics((r) => {
        // In the event of a problem, try again up to three times.
        if (r === 'ERROR' && this.retry < 3) {
          this.retry += 1;
          this.getComics();
          return;
        }

        // Get all comics from API.
        try {
          this.fromApi = JSON.parse(r).entries;
        } catch (e) {
          this.fromApi = r;
          return;
        }

        // Load comics into array.
        for (let i = 0; i < this.fromApi.length; i += 1) {
          this.setComics(this.fromApi[i]);
        }

        // Sort comics array by date.
        this.comics.sort((a, b) => H.timeCompare(a.date, b.date));
        this.$emit('setComics', this.comics);

        // Display latest comic on page.
        const latestComic = H.comic(this.comics[this.comics.length - 1]);
        const style = this.$el.querySelector('.home__comic').style;
        style.background = `#BBB url(${latestComic}) center no-repeat`;
        style.backgroundSize = 'contain';
        style.backgroundClip = 'content-box';
        style.display = 'block';
        setTimeout(() => { style.opacity = '0.5'; }, 0);
        setTimeout(() => { style.transition = 'opacity 0.1s linear'; }, 750);
      });
    },
    setComics(c) {
      for (let i = 0; i < c.images.length; i += 1) {
        const comic = ({
          title: (c.images.length > 1) ? `${c.title} (p${i + 1})` : `${c.title}`,
          date: H.saveTime(`${c.date} ${c.time}`, i),
          image: c.images[i].path,
          newspost: c.newspost,
        });

        this.comics.push(comic);
      }
    },
  },
  mounted() { this.getComics(); },
};
</script>

<style lang="scss" scoped>
@import '../tools.mixins';

.home{
  @include abs(0, 0, 1440px, 1440px);
  transform-origin: 0 0;
  background: url(../assets/bgd/home.jpg) center no-repeat;
  background-size: cover;

  &__comic{
    @include abs(357px, 359px, 483px, 686px);
    display: none;
    box-sizing: border-box;
    padding: 10px;
    border-radius: 10%;
    border: 0;
    opacity: 0;
    outline: none;
    transition: opacity 0.75s linear;
    cursor: pointer;
    &:focus, &:hover{ opacity: 1 !important; }
  }

  & > img{ pointer-events: none; }
  &__hal{ @include abs(46px, 94px, 569px, 340px); }
  &__frank{ @include abs(664px, 265px, 137px, 78px); }
  &__queen{ @include abs(840px, 675px, 282px, 361px); }
  &__bro{ @include abs(-529px, 1020px, 1474px, 469px); }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue